export default __webpack_public_path__ + "static/media/broker-template-2-fr.a031386c.svg";